import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { createAppKit } from "@reown/appkit/react";
import {
  bsc,
  bscTestnet,
  defineChain,
  type AppKitNetwork,
} from "@reown/appkit/networks";
import { isDevelopment, rpcURL, walletConnectProjectId } from "./env";
import { fallback, http } from "wagmi";
console.log("isDevelopment", isDevelopment);
const projectId = walletConnectProjectId || "YOUR_PROJECT_ID";
export const ccChainId = 2500;
export const ccRpcUrl = "https://rpc.consciousnesschain.com";
export const ccExplorerUrl = "https://cccscan.org";

export const ccMainnet = /*#__PURE__*/ defineChain({
  id: ccChainId,
  caipNetworkId: `eip155:${ccChainId}`,
  chainNamespace: "eip155",
  name: "Conscious Chain",
  nativeCurrency: { name: "Conscious Chain Coin", symbol: "CCC", decimals: 18 },
  rpcUrls: {
    default: { http: [ccRpcUrl] },
  },
  blockTime: 300,
  blockExplorers: {
    default: {
      name: "Conscious Chain Explorer",
      url: ccExplorerUrl,
    },
  },
  testnet: false,
});

const bscPublicRpcs = [
  rpcURL,
  "https://bsc-dataseed.bnbchain.org",
  "https://bsc-dataseed.nariox.org",
  "https://bsc-dataseed.defibit.io",
  "https://bsc-dataseed.ninicoin.io",
  "https://bsc.nodereal.io",
  "https://bsc-dataseed-public.bnbchain.org",
  "https://bnb.rpc.subquery.network/public",
];
export const bscChainId = isDevelopment ? bscTestnet.id : bsc.id;
const networks: [AppKitNetwork, ...AppKitNetwork[]] = isDevelopment
  ? [bscTestnet, ccMainnet]
  : [bsc, ccMainnet];
const metadata = {
  name: "TradingSkill",
  description: "TradingSkill DApp on BSC",
  url:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://tradingskill.ai",
  icons: ["/favicon.ico"],
};

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  customRpcUrls: {
    "eip155:56": [{ url: rpcURL }],
    "eip155:2500": [{ url: ccRpcUrl }],
  },
  transports: {
    [bsc.id]: fallback(bscPublicRpcs.map(url => http(url))),
    [ccMainnet.id]: http(ccRpcUrl),
  },
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: false,
    email: false,
    socials: false,
    swaps: false,
    onramp: false,
    history: false,
    send: false,
    receive: false,
  },
  customRpcUrls: {
    "eip155:56": [{ url: rpcURL }],
    "eip155:2500": [{ url: ccRpcUrl }],
  },
  enableWalletConnect: true,
  enableCoinbase: false, // 你做 BSC，不需要 coinbase
  enableInjected: true,
  enableEIP6963: true,
  themeMode: "dark",
});

export const wagmiConfig = wagmiAdapter.wagmiConfig as any;
